import React, { useMemo } from 'react';
import { reviewsFormat } from '@/pages/opinion/utils/value';
import EChartCommon from '@/pages/opinion/components/EChartCommon';
import {
  formatChartParamsDate,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';
import * as echarts from 'echarts';
import { useIntl } from 'umi';
import { getChartBufferWidth } from '@op/utils/systemUtil';

export default function Chart({
  statistics = { x: [], y: [] },
  text,
  dateType,
}: any) {
  const { formatMessage } = useIntl();
  const options = useMemo(() => {
    let legendData: {
      name: string;
      itemStyle: {
        color: string;
      };
    }[] = [];
    let xAxisData: string[] = statistics?.x || [];

    let seriesData: any[] = [
      {
        symbol: 'circle',
        symbolSize: 5,
        data: statistics?.y || [],
        type: 'line',
        lineStyle: {
          width: 2,
          color: '#376AE7',
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(55, 106, 231, 0.3)',
            },
            {
              offset: 1,
              color: 'rgba(209,230,250,0.00)',
            },
          ]),
        },
      },
    ];

    const option = {
      tooltip: {
        formatter: (param: any) => {
          let { name, data } = param?.[0] || {};
          return formatChartParamsDate({
            params: param,
            title: listTimeTitleFunc(name, dateType),
            textShowFun: (marker, listTitle) =>
              formatMessage({ id: listTitle }),
            valueFormat: (value) => {
              return reviewsFormat(value);
            },
            listTitleFunc: () => text,
            // recordDealwith: (item) => ({ ...item, value: reviewsFormat(data) }),
          });
        },
      },
      legend: {
        data: legendData,
      },
      grid: {
        top: '5px',
        left: getChartBufferWidth(5),
        right: '5px',
        bottom: '5px',
        containLabel: false,
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: 0,
          data: xAxisData,
          axisLabel: false,
          axisLine: false,
          axisTick: false,
          splitLine: false,
        },
      ],
      yAxis: {
        type: 'value',
        splitLine: false,
        axisLabel: false,
        boundaryGap: 0,
      },
      series: seriesData,
    };

    return option;
  }, [statistics, formatMessage]);

  return (
    <EChartCommon
      height={50}
      options={options}
      optionsProps={{ type: 'line', excludeOptions: ['axisPointer'] }}
    ></EChartCommon>
  );
}
